var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative h-full" },
    [
      _vm.processing
        ? _c(
            "span",
            {
              staticClass:
                "flex justify-center items-center absolute top-0 left-0 w-full h-full bg-cool-gray-900 text-white text-2xl z-10",
              class: [_vm.opacity, _vm.overlayBlockClasses],
            },
            [
              _vm.spinner
                ? _c("Spinner", { attrs: { color: "secondary" } })
                : _c("span", [_vm._v(" Processing... ")]),
            ],
            1
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }